export enum PlayersListTab {
  RANKING = 'ranking',
  TOTAL_BOOKS_READ = 'totalBooksRead'
}
